import {$createTableCellNode, $createTableRowNode, TableCellHeaderStates} from '@lexical/table';
import {$insertNodeToNearestRoot} from '@lexical/utils';
import {$createParagraphNode} from 'lexical';
import {$createEnhancedTableNode} from 'plugins/enhancedTableCells/EnhancedTableNode';

/**
 * Inserts a `rows` x `columns` table (first row as header) at the nearest root position to the
 * current selection. `$insertNodeToNearestRoot` splits the surrounding block and guarantees a
 * paragraph after the table so the author can keep typing below it.
 */
export const $insertDefaultTable = (rows = 3, columns = 3) => {
  const tableNode = $createEnhancedTableNode();
  for (let r = 0; r < rows; r++) {
    const rowNode = $createTableRowNode();
    for (let c = 0; c < columns; c++) {
      const cellNode = $createTableCellNode(
        r === 0 ? TableCellHeaderStates.ROW : TableCellHeaderStates.NO_STATUS
      );
      cellNode.append($createParagraphNode());
      rowNode.append(cellNode);
    }
    tableNode.append(rowNode);
  }
  $insertNodeToNearestRoot(tableNode);
  tableNode.getFirstDescendant()?.selectStart();
  return tableNode;
};
